import { useState, type CSSProperties } from 'react';
import { ProfileGlyph } from './icons';
export const NAV_VIEWS = ['Arena', 'Explore', 'Leaderboard'] as const;
export function TopBar({
  view,
  previewBalance,
  status,
  onView,
  onProfile,
}: {
  view: string;
  previewBalance?: string;
  status?: { tone: 'live' | 'warn' | 'down'; label: string };
  onView: (view: string) => void;
  onProfile: () => void;
}) {
  const activeIndex = NAV_VIEWS.findIndex((item) => item === view);
  const [indicatorIndex, setIndicatorIndex] = useState(
    Math.max(0, activeIndex),
  );
  // Keep the last position while fading out on Profile or another non-tab page.
  if (activeIndex >= 0 && activeIndex !== indicatorIndex)
    setIndicatorIndex(activeIndex);
  return (
    <header className={'top-bar' + (view === 'Explore' ? ' is-pinned' : '')}>
      <button
        type="button"
        className="rd-logo"
        onClick={() => onView('Arena')}
        aria-label="Run or Die home"
      >
        <span>R</span>
        <i aria-hidden="true" />
        <span>D</span>
      </button>
      <nav
        className="nav-pill"
        aria-label="Main navigation"
        data-selected={activeIndex >= 0}
        style={
          {
            '--nav-index': indicatorIndex,
            '--nav-count': NAV_VIEWS.length,
          } as CSSProperties
        }
      >
        <span className="nav-selection" aria-hidden="true" />
        {NAV_VIEWS.map((item) => (
          <button
            key={item}
            type="button"
            className={view === item ? 'is-active' : ''}
            aria-current={view === item ? 'page' : undefined}
            onClick={() => onView(item)}
          >
            <span className="nav-label">{item}</span>
          </button>
        ))}
      </nav>
      <div className="top-identity">
        <button
          type="button"
          className="identity-pill points-tab"
          onClick={() => onView('Points')}
          aria-current={view === 'Points' ? 'page' : undefined}
          aria-label={
            view === 'Points' && previewBalance !== undefined
              ? `Points preview balance: ${previewBalance} PTS`
              : 'Points'
          }
          title={view === 'Points' ? 'Demo points preview' : status?.label}
        >
          {status && <i className={'link-dot is-' + status.tone} />}
          {view === 'Points' && previewBalance !== undefined ? (
            <>
              <span>{previewBalance}</span>
              <small>PTS</small>
            </>
          ) : (
            <span>Points</span>
          )}
          {status && (
            <span className="sr-only" role="status">
              {status.label}
            </span>
          )}
        </button>
        <button
          type="button"
          className="avatar-button"
          onClick={onProfile}
          aria-label="Your profile"
        >
          <ProfileGlyph />
        </button>
      </div>
    </header>
  );
}
